import { useContext } from "react";
import { useLocation } from "react-router-dom";
import ApiContext from "context/apiContext";
import MyFavoritePlanFormContext from "context/MyFavoritePlanFormContext";

const FAV_PLAN_ROUTE_PREFIX = "/fav-plan";

export const isFavPlanRoute = (pathname) => pathname.startsWith(FAV_PLAN_ROUTE_PREFIX);

export const useQuoteFormContext = () => {
    const { pathname } = useLocation();
    const context = isFavPlanRoute(pathname) ? MyFavoritePlanFormContext : ApiContext;
    return useContext(context);
};
